import { Badge as ShadcnBadge } from "@/components/shadcn/ui/badge";
import clsx from "clsx";
import { ReactNode } from "react";

type Props = {
  variant?:
    | "primary"
    | "primaryOutline"
    | "primaryGhost"
    | "secondary"
    | "secondaryOutline"
    | "secondaryGhost"
    | "neutral"
    | "neutralOutline"
    | "neutralGhost";
  children: ReactNode;
  isSelectable?: boolean; //trueで選択可能になる（TODO機能、複数選択の検索時に使用する想定）
  isSelected?: boolean; //選択されているかどうか
  className?: string;
  onClick?: () => void;
};

const Badge: React.FC<Props> = ({
  variant,
  children,
  isSelectable,
  isSelected,
  className,
  onClick
}) => {
  return (
    <ShadcnBadge
      variant={
        isSelectable ? (isSelected ? "selected" : "selectedOutline") : variant
      }
      onClick={onClick}
      className={clsx(
        className,
        "m-0 cursor-pointer border px-[2.2rem] py-[1rem] text-md font-normal leading-none"
      )}
    >
      {children}
    </ShadcnBadge>
  );
};

export default Badge;
